import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';

function Filter({ filterItems, showAllItems, storeListBtn, setStoreListBtn, shoppingListBtn, setShoppingListBtn, uncheckedItemsBtn, setUncheckedItemsBtn }) {

  //const [storeListBtn, setStoreListBtn] = useState('clicked');
  //const [shoppingListBtn, setShoppingListBtn] = useState('unclicked');
  //const [uncheckedItemsBtn, setUncheckedItemsBtn] = useState('unclicked');
  
  const displayAllItems = () => {
    if (typeof showAllItems === "function") {
      const ok = window.confirm("AFFICHER MAGASIN VIRTUEL ?");
      if (ok) showAllItems();  
    }
  };

  return (
    <Form className='mb-3'>
      <Row className='g-2 mb-2'>
        <Col xs={12} sm={12}>
          <Button
            variant='secondary'
            onClick={() => {
              setStoreListBtn("clicked");
              setShoppingListBtn("unclicked");
              setUncheckedItemsBtn("unclicked");          
              displayAllItems();
            }}
            className={`btn-sm w-100 ${
              storeListBtn === "clicked" ? "btn-red-bootstrap" : ""
            }`}
            aria-label='Voir tous les articles du magasin virtuel'>
            Magasin virtuel
          </Button>
        </Col>
      </Row>
      <Row className='g-2'>
        <Col xs={6} sm={6}>
          <Button
            variant='secondary'
            onClick={() => {
              setStoreListBtn("unclicked");
              setShoppingListBtn("clicked");
              setUncheckedItemsBtn("unclicked");
              filterItems(false, true, false, []);
            }}
            className={`btn-sm w-100 ${
              shoppingListBtn === "clicked" ? "btn-red-bootstrap" : ""
            }`}>
            Liste d'achat
          </Button>
        </Col>
        <Col xs={6} sm={6}>
          <Button
            variant='secondary'
            onClick={() => {
              setStoreListBtn("unclicked");
              setShoppingListBtn("unclicked");
              setUncheckedItemsBtn("clicked");  
              filterItems(false, false, true, []);
            }}
            className={`btn-sm w-100 ${
              uncheckedItemsBtn === "clicked" ? "btn-red-bootstrap" : ""
            }`}>
            Non faits
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default Filter;